/** Модификаторы клавиатуры в расписании с учётом платформы.
 * На Mac Ctrl+клик — это правый клик (click не приходит, а drag не стартует),
 * поэтому там роль Ctrl играет ⌘. */

type ModifierKeys = Pick<MouseEvent, 'ctrlKey' | 'metaKey' | 'altKey'>;

export const IS_MAC_PLATFORM =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform);

/** Клик по слоту добавляет его к выделению: Ctrl, на Mac ⌘. */
export function hasSlotSelectModifier(e: ModifierKeys, isMac = IS_MAC_PLATFORM): boolean {
  return isMac ? e.metaKey : e.ctrlKey;
}

/** Перетаскивание копирует сессию: Ctrl, на Mac ⌘ или ⌥ (⌥ — системное копирование в macOS). */
export function hasCopyModifier(e: ModifierKeys, isMac = IS_MAC_PLATFORM): boolean {
  return isMac ? e.metaKey || e.altKey : e.ctrlKey;
}

/** dropEffect для сессии над сеткой; null — не трогать, пусть выберет браузер.
 * С зажатой ⌘ macOS разрешает только перемещение: явный 'copy' запретил бы drop.
 * Копию при этом всё равно делает обработчик drop по hasCopyModifier. */
export function getSessionDropEffect(
  e: ModifierKeys,
  draggingRecorded: boolean,
  isMac = IS_MAC_PLATFORM,
): DataTransfer['dropEffect'] | null {
  if (isMac && e.metaKey) return null;
  return draggingRecorded || hasCopyModifier(e, isMac) ? 'copy' : 'move';
}
